import { render, staticRenderFns } from "./403.vue?vue&type=template&id=a94a6456&scoped=true"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"
import style0 from "./403.vue?vue&type=style&index=0&id=a94a6456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94a6456",
  null
  
)

export default component.exports